<template>
  <div
    v-loading="loading"
    v-infinite-scroll="loadMore"
    :infinite-scroll-disabled="scrollDisabled"
  >
    <BEmptyBox
      v-if="histories.length === 0"
      display-only
    >
      <div>{{ $t('apiError.notFound') }}</div>
    </BEmptyBox>
    <template v-else-if="!loading">
      <div
        v-for="(historyItem, index) in histories"
        :key="historyItem.uuid || `${historyItem.type}-${historyItem.id}-${index}`"
        ref="historyItems"
        :data-uuid="`${historyItem.uuid}`"
      >
        <LeadHistoryCard
          v-model:pick-up-call-target-id="pickedCallTargetId"
          :history-item="historyItem"
          :call-target="historyItem.callTarget"
          :call-target-id="historyItem.callTarget?.id"
          :expand="false"
          :editable="false"
          :is-zoom-phone-connected="isZoomPhoneConnected"
          with-call-target
        />
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';
import { AccountHistory } from '@/api/openapi';
import { useScrollToHistoryItem } from '@/composable/user/use-scroll-to-history-item';
import { getIsZoomPhoneConnected } from '@/services/cti_service';
import LeadHistoryCard from '../general/LeadHistoryCard.vue';

type TProps = {
  histories: AccountHistory[];
  loading: boolean;
  loadMore: () => void;
  scrollDisabled: boolean;
};

const props = defineProps<TProps>();
const pickedCallTargetId = defineModel<number>('pickedCallTargetId');
const isZoomPhoneConnected = ref(false);
const historyItems = ref<HTMLElement[]>([]);

const route = useRoute();
const { scrollToHistoryItem } = useScrollToHistoryItem();
const scrollToHistoryItemIfNeeded = () => {
  const uuid = route.query.historyItem;
  if (uuid == null) return;
  scrollToHistoryItem(uuid.toString(), () => historyItems.value, () => props.loading);
};

onBeforeMount(async () => {
  isZoomPhoneConnected.value = await getIsZoomPhoneConnected();
  scrollToHistoryItemIfNeeded();
});
</script>

<style lang="scss" scoped>
.lead-history-card {
  margin-bottom: $basespace-50;
}
.b-empty-box {
  padding: $basespace-100;
}
</style>
